export const loadSession = (key) => {
    try {
        const serializedSession = sessionStorage.getItem(key);

        if (serializedSession === null) {
            return undefined;
        }

        return JSON.parse(serializedSession);
    } catch (err) {
        return undefined;
    }
};

export const saveSession = (key, value) => {
    try {
        const serializedSession = JSON.stringify(value);
        sessionStorage.setItem(key, serializedSession);
    } catch (err) {
        // ignore write errors to sessionStorage
    }
};

/**
 * Remove sessionStorage item by key
 *
 * @param {string} key Key
 */
export const removeSession = (key) => {
    try {
        sessionStorage.removeItem(key);
    } catch (err) {
        // ignore write errors to sessionStorage
    }
};
